import Vue from 'vue'
import { Swiper as SwiperClass, Pagination, Autoplay, EffectFade, Controller } from 'swiper/js/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'

SwiperClass.use([Pagination, Autoplay, EffectFade, Controller])

Vue.use(getAwesomeSwiper(SwiperClass))
